import { parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * The value stored by every phone field is an international E.164 number.
 *
 * Existing rows predate this rule, so readers fail softly and show their original text. New edits
 * do not: a local eight-digit number is ambiguous once the business has customers, vendors and
 * partners in more than one country, and must travel with the country the manager selected.
 */
export function isValidInternationalPhone(value: unknown): boolean {
  if (value == null || value === '') return true;
  if (typeof value !== 'string' || !value.startsWith('+')) return false;
  return parsePhoneNumberFromString(value)?.isValid() === true;
}

/** A phone number in the shape a person from that country expects to read. */
export function formatPhone(value: unknown): string {
  if (typeof value !== 'string' || !value.trim()) return '';
  const parsed = parsePhoneNumberFromString(value);
  if (!parsed?.isValid()) return value;
  // libphonenumber's international US format drops the familiar parentheses. Keep the country
  // code explicit while retaining the national format the owner asked for.
  if (parsed.country === 'US') return `+1 ${parsed.formatNational()}`;
  return parsed.formatInternational();
}

/** What a tel: link accepts, canonical when possible and conservative for a legacy row. */
export function dialablePhone(value: unknown): string {
  if (typeof value !== 'string') return '';
  return parsePhoneNumberFromString(value)?.number ?? value.replace(/[^\d+]/g, '');
}
